module.exports = __webpack_public_path__ + "img/hatch benedict hirschberg.83ac33bc.jpg";